import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Crown } from "lucide-react";
import { shopApi, fmt, apiImageUrl } from "../../lib/shopApi";

export const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    shopApi
      .get("/shop/products", { params: { featured: true } })
      .then((r) => setProducts(r.data.products.slice(0, 3)))
      .catch(() => {});
  }, []);

  if (products.length === 0) return null;

  return (
    <section data-testid="featured-products-section" className="py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] mb-4 flex items-center gap-2">
              <Crown className="w-4 h-4" /> The Crown Collection
            </p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white">
              Shop Loc <span className="italic gold-text">Care</span>
            </h2>
          </div>
          <Link
            to="/shop"
            data-testid="featured-view-shop-link"
            className="group inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#050505] px-10 py-4 rounded-full text-xs font-bold uppercase tracking-widest hover:-translate-y-0.5 hover:shadow-[0_10px_30px_rgba(212,175,55,0.35)] transition-all duration-300"
          >
            View Full Shop
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => {
            const price = p.sizes?.length ? Math.min(...p.sizes.map((s) => s.price_cents)) : p.sale_price_cents || p.price_cents;
            return (
              <Link
                key={p.id}
                to={`/shop/product/${p.slug}`}
                data-testid={`featured-product-${p.slug}`}
                className="group lux-card overflow-hidden !p-0 hover:-translate-y-1.5 transition-transform duration-500"
              >
                <div className="aspect-[4/3] overflow-hidden bg-[#0d0d0d]">
                  <img
                    src={apiImageUrl(p.images?.[0])}
                    alt={`${p.name} - Johannesburg locs product`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[1.1s] group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <p className="text-[#D4AF37]/70 text-[10px] uppercase tracking-[0.25em] mb-1.5">{p.category}</p>
                  <h3 className="font-serif text-lg text-white group-hover:text-[#D4AF37] transition-colors duration-300 mb-2">{p.name}</h3>
                  <p className="text-[#D4AF37] font-semibold">{p.sizes?.length > 1 ? `From ${fmt(price)}` : fmt(price)}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
